import { render } from "./usersBatchSetLossGames.vue?vue&type=template&id=50895f84&scoped=true"
import script from "./usersBatchSetLossGames.vue?vue&type=script&lang=js"
export * from "./usersBatchSetLossGames.vue?vue&type=script&lang=js"

import "./usersBatchSetLossGames.vue?vue&type=style&index=0&id=50895f84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50895f84"]])

export default __exports__